var map = {
	"./de/cv-play.png": "jVun",
	"./en/cv-play.png": "G+TS",
	"./es/cv-play.png": "HgmI",
	"./fr/cv-play.png": "vqYa",
	"./ja/cv-play.png": "4hHi",
	"./ko/cv-play.png": "T9zh",
	"./pt/cv-play.png": "aCgf",
	"./ru/cv-play.png": "6ULg",
	"./tc/cv-play.png": "m711",
	"./th/cv-play.png": "0pXd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7yI0";